import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { Input, Select } from 'antd';
import AcknowledgementLayout from "../../../../Containers/common/acknowledgement";
import CloseIcon from "../../../../Assets/images/close.svg";
import {SecondaryButton, TertiaryButton} from "../../../Common/button";
import messages from "./messages";
import {path} from "../../../../constant";

class DeleteConfirmationModal extends Component {
  constructor(props) {
    super(props);
      this.state = {
	  loading:false
    };
  }


    updateDelete = async () => {
	const { close, data} = this.props;
	const {category, callBack, violationKey, offenseKey} = data;
	if(category==="OFFENSE" || category==="REASON"){
	    callBack(offenseKey, violationKey);
	}
	else if(category==="VIOLATION"){
	    callBack(violationKey);
	}
	close();
    }

    
    formatMessage = data => this.props.intl.formatMessage(data);
   
    showStatusUI = () => {

	const {close, lang} = this.props;
	const {formatMessage} = this;
	
	return (
		<div>
		<div className="flex justify-content-end  mt30 mr40 ml40 clickable" onClick={close}>
		<img src={CloseIcon} alt="close modal"/>
		</div>

		<div className="flex justify-content-center align-items-center mt10 bold fontsize22">
		{formatMessage(messages.confirmationMsg)}
	    </div>

	    <div className="flex justify-content-center align-items-center mt40 medium fontsize28">
		{formatMessage(messages.undone)}
	    </div>
	    
		<div className="flex justify-content-center align-items-center mt20">
		<TertiaryButton
	    text={formatMessage(messages.no)}
            width="wpx120"
	    handleOnClick={close}
		/>
		<SecondaryButton
	    text={formatMessage(messages.yes)}
            width="wpx120"
	    marginLeft="ml20"
	    marginRight="mr20"
	    handleOnClick={this.updateDelete}
		/>
		</div>
		</div>
	);
    }
    

    render() {
	const {show} = this.props;
	if(!show){
	    return null;
	}

    return (
	    <AcknowledgementLayout>
	    {this.showStatusUI()}
	    </AcknowledgementLayout>
    );
  }
}

export default injectIntl(DeleteConfirmationModal);
